/*
 * 10-10-2026 Swiss-Relax: eigen leverdatumkiezer (vervangt de Buunto-app).
 *
 * Regels komen uit het shop-metafield swissrelax.levering (JSON), dat de leverkalender
 * (Google Apps Script) schrijft. snippets/js-variables.liquid zet dat in window.SR_LEVERING_CFG:
 *   weekdays  : leverdagen, 0 = zondag ... 6 = zaterdag
 *   firstDays : eerste leverdag = vandaag + firstDays (na het afsluituur 1 dag later)
 *   lastDays  : zo ver vooruit kan de klant kiezen
 *   cutoff    : afsluituur "HH:MM" (Belgische tijd)
 *   closed    : geblokkeerde datums ["2026-10-12", ...]
 *   open      : extra open datums op een dag die normaal dicht is (bv. een zondag)
 *
 * De klant kiest een datum op de productpagina. Die gaat mee als line item property
 * (Bezorgdatum / Date de livraison / Delivery date / Liefertermin) en komt zo op de
 * bestelling en in de bevestigingsmail. _leverdatum (ISO) is verborgen en wordt gebruikt
 * door de leverkalender om tag en ordernotitie te zetten.
 *
 * window.SRLevering is ook de bron voor assets/levering-dates.js (sofa-overzicht, USP-tegels).
 */
(function () {
  'use strict';

  var TZ = 'Europe/Brussels';

  function cfg() {
    var c = window.SR_LEVERING_CFG;
    if (!c || !c.weekdays) { return null; }
    return c;
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function fromIso(s) { var p = s.split('-'); return new Date(+p[0], +p[1] - 1, +p[2], 12); }

  // Vandaag en het uur in Belgische tijd, niet in die van de bezoeker.
  function shopNow() {
    var p = {};
    try {
      new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    } catch (e) {}
    var n = new Date();
    return {
      date: new Date(+p.year || n.getFullYear(), (+p.month || n.getMonth() + 1) - 1, +p.day || n.getDate(), 12),
      minutes: (p.hour != null ? +p.hour : n.getHours()) * 60 + (p.minute != null ? +p.minute : n.getMinutes())
    };
  }

  function firstDay(c) {
    var now = shopNow();
    var d = now.date;
    var cut = String(c.cutoff || '23:59').split(':');
    var cutMin = (+cut[0] || 0) * 60 + (+cut[1] || 0);
    d.setDate(d.getDate() + (+c.firstDays || 0) + (now.minutes >= cutMin ? 1 : 0));
    return d;
  }

  function lastDay(c) {
    var d = shopNow().date;
    d.setDate(d.getDate() + (c.lastDays != null ? +c.lastDays : 90));
    return d;
  }

  function isOpen(d, c) {
    c = c || cfg();
    if (!c) { return false; }
    var s = iso(d);
    if (s < iso(firstDay(c)) || s > iso(lastDay(c))) { return false; }
    if ((c.closed || []).indexOf(s) !== -1) { return false; }
    if ((c.open || []).indexOf(s) !== -1) { return true; }
    return (c.weekdays || []).indexOf(d.getDay()) !== -1;
  }

  function nextDates(count) {
    var c = cfg();
    if (!c) { return null; }
    var d = firstDay(c), end = lastDay(c), out = [];
    while (d <= end && out.length < (count || 1)) {
      if (isOpen(d, c)) { out.push(new Date(d.getTime())); }
      d.setDate(d.getDate() + 1);
    }
    return out.length ? out : null;
  }

  window.SRLevering = { config: cfg, isOpen: isOpen, nextDates: nextDates, iso: iso, fromIso: fromIso, firstDay: function () { var c = cfg(); return c ? firstDay(c) : null; } };

  /* ---------------------------------------------------------------- picker */

  var T = {
    nl: { label: 'Kies een datum van levering:', key: 'Bezorgdatum', lang: 'nl-BE', none: 'Er zijn momenteel geen leverdatums beschikbaar. Bel ons op 0800/61 112.', missing: 'Kies een leverdatum.', prev: 'Vorige maand', next: 'Volgende maand' },
    fr: { label: 'Choisissez une date de livraison :', key: 'Date de livraison', lang: 'fr-BE', none: 'Aucune date de livraison disponible pour le moment. Appelez-nous au 0800/61 112.', missing: 'Choisissez une date de livraison.', prev: 'Mois précédent', next: 'Mois suivant' },
    en: { label: 'Choose a delivery date:', key: 'Delivery date', lang: 'en-GB', none: 'No delivery dates available right now. Call us on 0800/61 112.', missing: 'Please choose a delivery date.', prev: 'Previous month', next: 'Next month' },
    de: { label: 'Wählen Sie einen Liefertermin:', key: 'Liefertermin', lang: 'de-BE', none: 'Im Moment sind keine Liefertermine verfügbar. Rufen Sie uns an unter 0800/61 112.', missing: 'Bitte wählen Sie einen Liefertermin.', prev: 'Vorheriger Monat', next: 'Nächster Monat' }
  };

  function fmt(d, lang, opts) {
    try { return new Intl.DateTimeFormat(lang, opts).format(d); } catch (e) { return iso(d); }
  }

  // Buunto staat tijdens de overgang nog aan als app embed: verbergen en zijn velden uitschakelen,
  // anders gaat er twee keer "Bezorgdatum" mee.
  function muteBuunto() {
    try { if (window.Buunto && window.Buunto.datePicker && window.Buunto.datePicker.setBypassMode) { window.Buunto.datePicker.setBypassMode(true); } } catch (e) {}
    Array.prototype.forEach.call(document.querySelectorAll('#buunto-date-picker, .buunto-date-picker'), function (w) {
      w.style.display = 'none';
      Array.prototype.forEach.call(w.querySelectorAll('input, select, textarea'), function (i) { i.disabled = true; });
    });
    Array.prototype.forEach.call(document.querySelectorAll('input[name^="properties["]'), function (i) {
      if (!i.closest('[data-sr-leverdatum]') && i.closest('#buunto-date-picker')) { i.disabled = true; }
    });
  }

  function initPicker(root) {
    if (root.__srld) { return; }
    root.__srld = true;
    var loc = (root.getAttribute('data-locale') || document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
    var t = T[loc] || T.nl;
    var c = cfg();

    var field = root.querySelector('[data-srld-field]');
    var text = root.querySelector('[data-srld-text]');
    var cal = root.querySelector('[data-srld-cal]');
    var visible = root.querySelector('[data-srld-visible]');
    var hidden = root.querySelector('[data-srld-iso]');
    var err = root.querySelector('[data-srld-err]');
    root.querySelector('[data-srld-label]').textContent = t.label;
    visible.name = 'properties[' + t.key + ']';

    var first = nextDates(1);
    var initial = first && first[0];
    // Snel kopen of een variantwissel bouwt het blok opnieuw: hou de datum die de klant al koos.
    if (window.__srldLast && isOpen(fromIso(window.__srldLast), c)) { initial = fromIso(window.__srldLast); }
    if (!c || !first) {
      field.hidden = true;
      visible.disabled = true; hidden.disabled = true;
      err.textContent = t.none; err.hidden = false;
      return;
    }

    var state = { sel: initial, month: new Date(initial.getFullYear(), initial.getMonth(), 1, 12) };

    function choose(d) {
      state.sel = d;
      text.textContent = fmt(d, t.lang, { day: 'numeric', month: 'long', year: 'numeric' });
      visible.value = fmt(d, t.lang, { day: 'numeric', month: 'long', year: 'numeric' });
      hidden.value = iso(d);
      err.hidden = true;
    }

    // Maandag als eerste dag van de week.
    var dayNames = [];
    for (var k = 0; k < 7; k++) {
      var dn = fmt(new Date(2024, 0, 1 + k, 12), t.lang, { weekday: 'short' }).replace('.', '');
      dayNames.push(dn.charAt(0).toUpperCase() + dn.slice(1, 2));
    }

    function render() {
      var m = state.month;
      var minMonth = new Date(first[0].getFullYear(), first[0].getMonth(), 1, 12);
      var last = lastDay(c);
      var maxMonth = new Date(last.getFullYear(), last.getMonth(), 1, 12);
      var title = fmt(m, t.lang, { month: 'long', year: 'numeric' });
      title = title.charAt(0).toUpperCase() + title.slice(1);
      var h = '<div class="srld-head">' +
        '<button type="button" class="srld-nav" data-nav="-1" aria-label="' + t.prev + '"' + (m <= minMonth ? ' disabled' : '') + '>&larr;</button>' +
        '<strong>' + title + '</strong>' +
        '<button type="button" class="srld-nav" data-nav="1" aria-label="' + t.next + '"' + (m >= maxMonth ? ' disabled' : '') + '>&rarr;</button></div>' +
        '<div class="srld-grid" role="grid">';
      dayNames.forEach(function (n) { h += '<span class="srld-dn">' + n + '</span>'; });
      var offset = (m.getDay() + 6) % 7;
      for (var i = 0; i < offset; i++) { h += '<span></span>'; }
      var d = new Date(m.getTime());
      while (d.getMonth() === m.getMonth()) {
        var open = isOpen(d, c);
        var s = iso(d);
        var selected = state.sel && iso(state.sel) === s;
        h += '<button type="button" class="srld-day' + (selected ? ' is-sel' : '') + '" data-day="' + s + '"' + (open ? '' : ' disabled') +
          ' aria-label="' + fmt(d, t.lang, { weekday: 'long', day: 'numeric', month: 'long' }) + '"' + (selected ? ' aria-pressed="true"' : '') + '>' + d.getDate() + '</button>';
        d.setDate(d.getDate() + 1);
      }
      cal.innerHTML = h + '</div>';
    }

    function openCal() { render(); cal.hidden = false; field.setAttribute('aria-expanded', 'true'); }
    function closeCal() { cal.hidden = true; field.setAttribute('aria-expanded', 'false'); }

    field.addEventListener('click', function () { cal.hidden ? openCal() : closeCal(); });
    cal.addEventListener('click', function (e) {
      var nav = e.target.closest('[data-nav]');
      if (nav) { state.month.setMonth(state.month.getMonth() + (+nav.getAttribute('data-nav'))); render(); return; }
      var day = e.target.closest('[data-day]');
      if (day && !day.disabled) { choose(fromIso(day.getAttribute('data-day'))); window.__srldLast = hidden.value; closeCal(); field.focus(); }
    });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) { closeCal(); } });
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCal(); } });

    // Zekerheid: zonder datum niet in de winkelwagen.
    var form = visible.form;
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!hidden.value) { e.preventDefault(); e.stopImmediatePropagation(); err.textContent = t.missing; err.hidden = false; }
      }, true);
    }

    choose(initial);
    muteBuunto();
    var n = 0;
    var timer = setInterval(function () { muteBuunto(); if (++n > 40) { clearInterval(timer); } }, 250);
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sr-leverdatum]'), initPicker);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load', initAll);
  // Snel kopen (collectiepagina's) en variantwissels voegen het blok later toe.
  try {
    var pending = false;
    new MutationObserver(function () {
      if (pending) { return; }
      pending = true;
      setTimeout(function () { pending = false; initAll(); }, 50);
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
